<template>
  <v-container fluid>
    <v-breadcrumbs :items="breadItems"
                   class="breadcrumb mx-16">
    </v-breadcrumbs>
    <!-- <v-card> -->
    <v-row dense
           class="mx-16 justify-center">
      <!-- Splicing Knowledge Part -->
      <v-col sm="12"
             md="12"
             lg="12"
             cols="12"
             class="mb-n3 mt-1"
             id="knowledge">
        <v-alert color="info"
                 text
                 dense
                 outlined
                 elevation="1"
                 icon="mdi-library">
          1. The <span style="color:red; font-weight:bold">Cancer Associated Splicing Events (CASE)</span> was collected by manually curating published literatures.
          <!-- Download function -->
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="info"
                     v-bind="attrs"
                     v-on="on"
                     small
                     rounded
                     class="mx-2"
                     :loading="download_all_loading"
                     @click="downloadAll">
                <span class="font-weight-bold">Download All
                  <v-icon small>mdi-download</v-icon>
                </span>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item>
                <v-list-item-title>
                  <json-excel type="xls"
                              :data="all_knowledge_result"
                              name="CASE_all.xls">
                    <v-btn text
                           block> <span class="font-weight-bold">xls</span> </v-btn>
                  </json-excel>
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>
                  <json-excel type="csv"
                              :data="all_knowledge_result"
                              name="CASE_all.csv">
                    <v-btn text
                           block> <span class="font-weight-bold">csv</span> </v-btn>
                  </json-excel>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-alert>
      </v-col>
      <!-- Download by Gene Name -->
      <v-col cols="12"
             sm="12"
             md="4"
             lg="4">
        <v-card>
          <v-card-title class="font-weight-bold grey lighten-2">
            Download by Gene Name(s)
          </v-card-title>
          <v-card-text class="mt-3">
            <v-combobox v-model="gene_select"
                        filled
                        rounded
                        dense
                        hide-no-data
                        hide-selected
                        multiple
                        small-chips
                        clearable
                        clear-icon="mdi-close-circle"
                        :loading="gene_loading"
                        :items="gene_items"
                        :search-input.sync="gene_search"
                        :messages="gene_message"
                        :error-messages="gene_error_message">
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 3"
                        small
                        color="white">
                  <span>{{ item }}</span>
                </v-chip>
                <span v-if="index == 3"
                      class="grey--text text-caption">
                  (+{{ gene_select.length - 3 }} others)
                </span>
              </template>
            </v-combobox>
          </v-card-text>
          <v-card-actions class="mt-n6">
            <v-spacer></v-spacer>
            <!-- Download function -->
            <v-menu offset-y
                    :disabled="gene_disabled">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="info"
                       v-bind="attrs"
                       v-on="on"
                       rounded
                       small
                       @click="downloadByGeneName">
                  <span class="font-weight-bold">Download <v-icon small>mdi-download</v-icon></span>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item>
                  <v-list-item-title>
                    <json-excel type="xls"
                                :data="gene_query_result"
                                name="CASE_Gene.xls">
                      <v-btn text
                             block> <span class="font-weight-bold">xls</span> </v-btn>
                    </json-excel>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>
                    <json-excel type="csv"
                                :data="gene_query_result"
                                name="CASE_Gene.csv">
                      <v-btn text
                             block> <span class="font-weight-bold">csv</span> </v-btn>
                    </json-excel>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-spacer></v-spacer>
          </v-card-actions>
          <v-divider></v-divider>
          <div class="mx-4 font-weight-bold">RESTful API</div>
          <v-divider></v-divider>
          <v-card-text v-show="gene_api_string=='' || gene_api_string==null">
            {{gene_api_uri+gene_api_string}}
          </v-card-text>
          <v-card-text v-show="gene_api_string">
            <a :href="gene_api_uri+gene_api_string"
               target="_blank">{{gene_api_uri+gene_api_string}}</a>
          </v-card-text>
        </v-card>
      </v-col>
      <!-- Download by Cancer Type -->
      <v-col cols="12"
             sm="12"
             md="4"
             lg="4">
        <v-card>
          <v-card-title class="font-weight-bold grey lighten-2">
            Download by Cancer Type(s)
          </v-card-title>
          <v-card-text class="mt-3">
            <v-combobox v-model="cancer_select"
                        filled
                        rounded
                        dense
                        hide-no-data
                        hide-selected
                        multiple
                        small-chips
                        clearable
                        clear-icon="mdi-close-circle"
                        :loading="cancer_loading"
                        :items="cancer_items"
                        :search-input.sync="cancer_search"
                        :messages="cancer_message"
                        :error-messages="cancer_error_message">
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 1"
                        small
                        color="white">
                  <span>{{ item }}</span>
                </v-chip>
                <span v-if="index == 1"
                      class="grey--text text-caption">
                  (+{{ cancer_select.length - 1 }} others)
                </span>
              </template>
            </v-combobox>
          </v-card-text>
          <v-card-actions class="mt-n6">
            <v-spacer></v-spacer>
            <!-- Download function -->
            <v-menu offset-y
                    :disabled="cancer_disabled">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="info"
                       v-bind="attrs"
                       v-on="on"
                       rounded
                       small
                       @click="downloadByCancerType">
                  <span class="font-weight-bold">Download <v-icon small>mdi-download</v-icon></span>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item>
                  <v-list-item-title>
                    <json-excel type="xls"
                                :data="cancer_query_result"
                                name="CASE_Cancer.xls">
                      <v-btn text
                             block> <span class="font-weight-bold">xls</span> </v-btn>
                    </json-excel>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>
                    <json-excel type="csv"
                                :data="cancer_query_result"
                                name="CASE_Cancer.csv">
                      <v-btn text
                             block> <span class="font-weight-bold">csv</span> </v-btn>
                    </json-excel>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-spacer></v-spacer>
          </v-card-actions>
          <v-divider></v-divider>
          <div class="mx-4 font-weight-bold">RESTful API</div>
          <v-divider></v-divider>
          <v-card-text v-show="cancer_api_string=='' || cancer_api_string==null">
            {{cancer_api_uri+cancer_api_string}}
          </v-card-text>
          <v-card-text v-show="cancer_api_string">
            <a :href="cancer_api_uri+cancer_api_string"
               target="_blank">{{cancer_api_uri+cancer_api_string}}</a>
          </v-card-text>
        </v-card>
      </v-col>
      <!-- Download by AS Event Type -->
      <v-col cols="12"
             sm="12"
             md="4"
             lg="4">
        <v-card>
          <v-card-title class="font-weight-bold grey lighten-2">
            Download by AS Event Type(s)
          </v-card-title>
          <v-card-text class="mt-3">
            <!-- 此处不能加 hide-selected 属性 -->
            <v-select v-model="selectedASTypes"
                      filled
                      rounded
                      dense
                      hide-no-data
                      multiple
                      small-chips
                      :items="as_items"
                      :messages="as_message"
                      clearable
                      clear-icon="mdi-close-circle">
              <template v-slot:prepend-item>
                <v-list-item ripple
                             @click="toggle_astypes">
                  <v-list-item-action>
                    <v-icon :color="selectedASTypes.length > 0 ? 'success' : ''">
                      {{ as_icon }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      Select All
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
              </template>
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 3"
                        small
                        color="white">
                  <span>{{ item }}</span>
                </v-chip>
                <span v-if="index == 3"
                      class="grey--text text-caption">
                  (+{{ selectedASTypes.length - 3 }} others)
                </span>
              </template>
            </v-select>
          </v-card-text>
          <v-card-actions class="mt-n6">
            <v-spacer></v-spacer>
            <!-- Download function -->
            <v-menu offset-y
                    :disabled="as_disabled">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="info"
                       v-bind="attrs"
                       v-on="on"
                       rounded
                       small
                       @click="downloadByASType">
                  <span class="font-weight-bold">Download <v-icon small>mdi-download</v-icon></span>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item>
                  <v-list-item-title>
                    <json-excel type="xls"
                                :data="as_query_result"
                                name="CASE_AS_Type.xls">
                      <v-btn text
                             block> <span class="font-weight-bold">xls</span> </v-btn>
                    </json-excel>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>
                    <json-excel type="csv"
                                :data="as_query_result"
                                name="CASE_AS_Type.csv">
                      <v-btn text
                             block> <span class="font-weight-bold">csv</span> </v-btn>
                    </json-excel>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-spacer></v-spacer>
          </v-card-actions>
          <v-divider></v-divider>
          <div class="mx-4 font-weight-bold">RESTful API</div>
          <v-divider></v-divider>
          <v-card-text v-show="as_api_string=='' || as_api_string==null">
            {{as_api_uri+as_api_string}}
          </v-card-text>
          <v-card-text v-show="as_api_string">
            <a :href="as_api_uri+as_api_string"
               target="_blank">{{as_api_uri+as_api_string}}</a>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Splicing Datasets Part -->
      <v-col sm="12"
             md="12"
             lg="12"
             cols="12"
             class="mt-8 mb-n3"
             id="dataset">
        <v-alert color="info"
                 text
                 dense
                 outlined
                 elevation="1"
                 icon="mdi-database-arrow-down">
          2. The <span style="color:red; font-weight:bold">Computationally Putative Splicing Events (CPSE)</span> was mined from
          <a href="https://gdc.cancer.gov/about-data/publications/PanCanAtlas-Splicing-2018"
             target="_blank"><u>the Pan-Cancer Atlas Splicing Project</u></a>.
             <!-- and tumor-related GEO projects. -->
        </v-alert>
      </v-col>

      <!-- TCGA Project -->
      <v-col sm="12"
             md="12"
             lg="12"
             cols="12">
        <v-card-title class="font-weight-bold grey lighten-2">
          TCGA Projects
        </v-card-title>
        <v-data-table dense
                      class="data-table-style mt-1"
                      :headers="tcga_headers"
                      :items="tcga_summary"
                      fixed-header
                      loading-text="Loading... Please wait">
          <!-- item.project_id slot -->
          <template v-slot:[`item.project_id`]="{item}">
            <a @click="$router.push('/projects/tcga/'+item.project_id)">
              <span class="font-weight-bold">{{item.project_id}}</span>
            </a>
          </template>
          <!-- item.download_info slot -->
          <template v-slot:[`item.download_info`]="{item}">
            <a @click="downloadFiles(item.info_url)">
              <span class="font-weight-bold">{{item.download_info}}</span>
            </a>
            <v-icon color="info"
                    small>mdi-download</v-icon>
          </template>
          <!-- item.download_psi slot -->
          <template v-slot:[`item.download_psi`]="{item}">
            <a @click="downloadFiles(item.psi_url)">
              <span class="font-weight-bold">{{item.download_psi}}</span>
            </a>
            <v-icon color="info"
                    small>mdi-download</v-icon>
          </template>
        </v-data-table>
      </v-col>

      <!-- GTEx Project -->
      <v-col sm="12"
             md="12"
             lg="12"
             cols="12">
        <v-card-title class="font-weight-bold grey lighten-2">
          GTEx Projects
        </v-card-title>
        <v-data-table dense
                      class="data-table-style mt-1"
                      :headers="gtex_headers"
                      :items="gtex_summary"
                      fixed-header
                      loading-text="Loading... Please wait">
          <!-- item.project_id slot -->
          <template v-slot:[`item.project_id`]="{item}">
            <a @click="$router.push('/projects/gtex/'+item.project_id)">
              <span class="font-weight-bold">{{item.project_id}}</span>
            </a>
          </template>
          <!-- item.download_info slot -->
          <template v-slot:[`item.download_info`]="{item}">
            <a @click="downloadFiles(item.info_url)">
              <span class="font-weight-bold">{{item.download_info}}</span>
            </a>
            <v-icon color="info"
                    small>mdi-download</v-icon>
          </template>
          <!-- item.download_psi slot -->
          <template v-slot:[`item.download_psi`]="{item}">
            <a @click="downloadFiles(item.psi_url)">
              <span class="font-weight-bold">{{item.download_psi}}</span>
            </a>
            <v-icon color="info"
                    small>mdi-download</v-icon>
          </template>
        </v-data-table>
      </v-col>

      <!-- GEO Project -->
      <!-- <v-col sm="12"
             md="12"
             lg="12"
             cols="12">
        <v-card-title class="font-weight-bold grey lighten-2">
          GEO Projects
        </v-card-title>
        <v-data-table dense
                      class="data-table-style mt-1"
                      :headers="geo_headers"
                      :items="geo_summary"
                      fixed-header
                      loading-text="Loading... Please wait">
          <template v-slot:[`item.project_id`]="{item}">
            <a @click="$router.push('/projects/geo/'+item.project_id)">
              <span class="font-weight-bold">{{item.project_id}}</span>
            </a>
          </template>
          <template v-slot:[`item.download_info`]="{item}">
            <a @click="downloadFiles(item.info_url)">
              <span class="font-weight-bold">{{item.download_info}}</span>
            </a>
            <v-icon color="info"
                    small>mdi-download</v-icon>
          </template>
          <template v-slot:[`item.download_psi`]="{item}">
            <a @click="downloadFiles(item.psi_url)">
              <span class="font-weight-bold">{{item.download_psi}}</span>
            </a>
            <v-icon color="info"
                    small>mdi-download</v-icon>
          </template>
        </v-data-table>
      </v-col> -->

      <!-- TCGA-GTEx-Common Project -->
      <v-col sm="12"
             md="12"
             lg="12"
             cols="12">
        <v-card-title class="font-weight-bold grey lighten-2">
          TCGA-GTEx Common Splicing Events
        </v-card-title>
        <v-data-table dense
                      class="data-table-style mt-1"
                      :headers="tcga_gtex_common_headers"
                      :items="tcga_gtex_common_summary"
                      fixed-header
                      loading-text="Loading... Please wait">
          <!-- item.download_filename slot -->
          <template v-slot:[`item.download_filename`]="{item}">
            <a @click="downloadFiles(item.download_url)">
              <span class="font-weight-bold">{{item.download_filename}}</span>
            </a>
            <v-icon color="info"
                    small>mdi-download</v-icon>
          </template>
        </v-data-table>
      </v-col>

      <!-- TCGA-GTEx-DASE Project -->
      <v-col sm="12"
             md="12"
             lg="12"
             cols="12">
        <v-card-title class="font-weight-bold grey lighten-2">
          TCGA-GTEx Differential Splicing Events
        </v-card-title>
        <v-data-table dense
                      calculate-widths
                      class="data-table-style mt-1"
                      :headers="tcga_gtex_dase_headers"
                      :items="tcga_gtex_dase_summary"
                      fixed-header
                      loading-text="Loading... Please wait">
          <!-- item.download_filename slot -->
          <template v-slot:[`item.download_filename`]="{item}">
            <a @click="downloadFiles(item.download_url)">
              <span class="font-weight-bold">{{item.download_filename}}</span>
            </a>
            <v-icon color="info"
                    small>mdi-download</v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <!-- </v-card> -->

    <back-to-top></back-to-top>
  </v-container>
</template>

<script>
import { downloadFiles, getDownloadPageSummary } from 'node/download.js';
import { getAllGeneFromSV, getAllCancerFromSV } from 'node/browse';
import {
  getFilteredSpliceVariantByGenename, getFilteredSpliceVariantByCancername,
  getFilteredSpliceVariantByAstype,
} from 'node/search.js';
import { getSpliceKnowledge } from 'node/browse';
import JsonExcel from 'vue-json-excel';
import BackToTop from '@/components/main/BackToTop';
export default {
  name: 'Download',
  components: {
    JsonExcel,
    BackToTop
  },
  data() {
    return {
      breadItems: [
        {
          text: 'Home',
          disabled: false,
          href: '/ascancer/home',
        },
        {
          text: 'Download',
          disabled: true,
        },
      ],

      all_knowledge_result: [],
      download_all_loading: false,

      // Download by Gene Name:
      gene_select: [],
      gene_api_uri: "https://ngdc.cncb.ac.cn/ascancer/api/browse/knowledge?genename=",
      gene_api_string: "",
      gene_search: null,
      gene_list: [],
      gene_items: [],
      gene_loading: false,
      gene_message: "Please enter 1 or more gene names.",
      gene_error_message: null,
      gene_query_result: [],
      gene_disabled: true,

      // Download by Cancer Type:
      cancer_select: [],
      cancer_api_uri: "https://ngdc.cncb.ac.cn/ascancer/api/browse/knowledge?cancername=",
      cancer_api_string: "",
      cancer_search: null,
      cancer_list: [],
      cancer_items: [],
      cancer_loading: false,
      cancer_message: "Please enter 1 or more cancer types.",
      cancer_error_message: null,
      cancer_query_result: [],
      cancer_disabled: true,

      // Download by AS Event Type:
      selectedASTypes: [],
      as_api_uri: "https://ngdc.cncb.ac.cn/ascancer/api/browse/knowledge?astype=",
      as_api_string: "",
      as_items: ["ES", "A3SS", "A5SS", "IR", "MEX", "Complex"],
      as_message: "Please enter 1 or more AS event types",
      as_query_result: [],
      as_disabled: true,

      tcga_headers: [{ text: 'Project ID', value: 'project_id', align: 'start', sortable: true, width: "25%" },
      // { text: 'Tumor Number', value: 'tumor_no', align: 'center', sortable: true, },
      // { text: 'Normal Number', value: 'normal_no', align: 'center', sortable: true, },
      { text: 'Sample Number', value: 'total_no', align: 'start', sortable: true, width: "25%" },
      { text: 'Event Info', value: 'download_info', align: 'start', sortable: true, width: "25%" },
      { text: 'Event PSI', value: 'download_psi', align: 'start', sortable: true, width: "25%" },
      ],
      tcga_summary: [],

      gtex_headers: [{ text: 'Project ID', value: 'project_id', align: 'start', sortable: true, width: "25%" },
      { text: 'Sample Number', value: 'total_no', align: 'start', sortable: true, width: "25%" },
      { text: 'Event Info', value: 'download_info', align: 'start', sortable: true, width: "25%" },
      { text: 'Event PSI', value: 'download_psi', align: 'start', sortable: true, width: "25%" },
      ],
      gtex_summary: [],

      geo_headers: [{ text: 'Project ID', value: 'project_id', align: 'start', sortable: true, width: "25%" },
      { text: 'Sample Number', value: 'total_no', align: 'start', sortable: true, width: "25%" },
      { text: 'Event Info', value: 'download_info', align: 'start', sortable: true, width: "25%" },
      { text: 'Event PSI', value: 'download_psi', align: 'start', sortable: true, width: "25%" },
      ],
      geo_summary: [],

      tcga_gtex_common_headers: [{ text: 'Project ID', value: 'tcga_gtex_common', align: 'start', sortable: true, width: "25%" },
      { text: 'TCGA Project ID', value: 'cancer_type', align: 'start', sortable: true, width: "25%" },
      { text: 'GTEx Project ID', value: 'tissue_type', align: 'start', sortable: true, width: "25%" },
      { text: 'Event PSI', value: 'download_filename', align: 'start', sortable: true, width: "25%" },
      ],
      tcga_gtex_common_summary: [],

      tcga_gtex_dase_headers: [{ text: 'Project ID', value: 'tcga_gtex_common', align: 'start', sortable: true, width: "25%" },
      { text: 'TCGA Project ID', value: 'cancer_type', align: 'start', sortable: true, width: "25%" },
      { text: 'GTEx Project ID', value: 'tissue_type', align: 'start', sortable: true, width: "25%" },
      { text: 'Event PSI', value: 'download_filename', align: 'start', sortable: true, width: "25%" },
      ],
      tcga_gtex_dase_summary: [],
    }
  },
  created() {
    this.getDownloadPageSummary();

  },
  mounted() {
    this.getAllGeneFromSV();
    this.getAllCancerFromSV();
  },
  computed: {
    selectedAllASTypes() {
      return this.selectedASTypes.length === this.as_items.length
    },
    selectedSomeASTypes() {
      return this.selectedASTypes.length > 0 && !this.selectedAllASTypes
    },
    as_icon() {
      if (this.selectedAllASTypes) return 'mdi-close-box'
      if (this.selectedSomeASTypes) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
  },
  watch: {
    gene_select(val) {
      // console.log(val);
      if (val == null || val.length == 0) {
        this.gene_message = "Please enter 1 or more gene names."
        this.gene_api_string = null;
        this.gene_disabled = true;
        // Check whether each gene of gene_select is in the gene_list array
      } else if (val && val.length > 0 && val.every(v => this.gene_list.includes(v))) {
        this.gene_select = val;
        this.gene_message = null;
        this.gene_api_string = val.join(',')
        this.gene_disabled = false;
      } else {
        // window.alert("Sorry, we cant' find the gene you entered.");
        this.gene_select.pop();
        this.gene_disabled = true;
      };
      // limit the max search number
      //   if (val.length > 6) {
      //     this.$nextTick(() => this.gene_select.pop());
      //   }
    },
    gene_search(val) {
      val && val !== this.gene_select && this.geneQuerySelections(val);
    },
    cancer_select(val) {
      if (val == null || val.length == 0) {
        this.cancer_message = "Please enter 1 or more cancer types."
        this.cancer_api_string = null;
        this.cancer_disabled = true;
        // Check whether each cancer of cancer_select is in the cancer_list array
      } else if (val && val.length > 0 && val.every(v => this.cancer_list.includes(v))) {
        this.cancer_select = val;
        this.cancer_api_string = val.join(',')
        this.cancer_message = null;
        this.cancer_disabled = false;
      } else {
        // window.alert("Sorry, we cant' find the cancer type you entered.");
        this.cancer_select.pop();
        this.cancer_disabled = true;
      };
    },
    cancer_search(val) {
      val && val !== this.cancer_select && this.cancerQuerySelections(val);
    },
    selectedASTypes(val) {
      if (val == null || val.length == 0) {
        this.as_message = "Please enter 1 or more AS event types";
        this.as_api_string = "";
        this.as_disabled = true;
      } else {
        this.as_message = "";
        this.as_api_string = val.join(',')
        this.as_disabled = false;
      }
    },
  },
  methods: {
    async downloadAll() {
      if (this.all_knowledge_result.length > 0) {
        this.download_all_loading = false;
      } else {
        this.download_all_loading = true;
        let params = {};
        params.page = 0;
        params.size = 3000;
        await getSpliceKnowledge(params).then((data) => {
          if (data) {
            this.download_all_loading = false;
            // console.log(data);
            this.all_knowledge_result = data.items;
          }
        });
      }
    },
    async getAllGeneFromSV() {
      await getAllGeneFromSV().then(
        data => {
          if (data) {
            // console.log(data);
            this.gene_list = [...data[0], ...data[1]];
          }
        }
      ).catch(err => console.error(err))
    },
    geneQuerySelections(v) {
      this.gene_message = null;
      this.gene_error_message = null;
      this.gene_loading = true;
      setTimeout(() => {
        this.gene_items = this.gene_list.filter(e => {
          let pattern = new RegExp(v, 'ig');
          return pattern.test(e);
          //   return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) === 0
        })
        this.gene_loading = false
        // show the no data tips when the search result is null
        if (this.gene_items.length == 0) {
          this.gene_error_message = "Sorry, we cant' find the gene you entered.";
        }
      }, 500)
    },
    downloadByGeneName() {
      let genename = this.gene_select;
      if (genename == null || genename.length == 0) {
        this.gene_error_message = "Please enter 1 or more gene names."
        window.alert("Sorry, please enter 1 or more gene names.");
      } else {
        let genenames;
        // Determine whether is an array: Array.isArray()
        if (Array.isArray(genename)) {
          genenames = genename.join(',');
        } else {
          genenames = genename;
        }
        // console.log(genenames);
        getFilteredSpliceVariantByGenename(genenames).then(data => {
          // console.log(data);
          this.gene_query_result = data
        }
        ).catch(err =>
          console.error(err))
      }
    },
    // cancer_type input
    async getAllCancerFromSV() {
      await getAllCancerFromSV().then(data => {
        if (data) {
          // console.log(data);
          let cancerNames = [];
          data.forEach((v, i, a) => {
            if (v.indexOf(',')) {
              let arr = v.split(', ')
              cancerNames.push(...arr)
            } else {
              cancerNames.push(v)
            }
          })
          // console.log(cancerNames);
          this.cancer_list = [...new Set(cancerNames)]; // uniq array
        }
      }).catch(err => console.error(err))
    },
    cancerQuerySelections(v) {
      this.cancer_message = null;
      this.cancer_error_message = null;
      this.cancer_loading = true;
      setTimeout(() => {
        this.cancer_items = this.cancer_list.filter(e => {
          let pattern = new RegExp(v, 'ig');
          return pattern.test(e);
          //   return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) === 0
        })
        this.cancer_loading = false;
        // show the no data tips when the search result is null
        if (this.cancer_items.length == 0) {
          this.cancer_error_message = "Sorry, we cant' find the cancer type you entered.";
        }
      }, 500)
    },
    downloadByCancerType() {
      let cancer = this.cancer_select;
      if (cancer == null || cancer.length == 0) {
        this.cancer_error_message = "Please enter 1 or more cancer types."
        window.alert("Sorry, please enter 1 or more cancer types.");
      } else {
        let cancertypes;
        // Determine whether is an array: Array.isArray()
        if (Array.isArray(cancer)) {
          cancertypes = cancer.join(',');
        } else {
          cancertypes = cancer;
        }
        // console.log(cancertypes);
        getFilteredSpliceVariantByCancername(cancertypes).then(data =>
          //   console.log(data)
          this.cancer_query_result = data
        ).catch(err =>
          console.error(err))
      }
    },
    // as_type input
    toggle_astypes() {
      this.$nextTick(() => {
        if (this.selectedAllASTypes) {
          this.selectedASTypes = []
        } else {
          this.selectedASTypes = this.as_items.slice()
        }
      })
    },
    downloadByASType() {
      let astype = this.selectedASTypes;
      if (astype == null || astype.length == 0) {
        window.alert("Sorry, please enter 1 or more AS event types.");
      } else {
        let astypes;
        // Determine whether is an array: Array.isArray()
        if (Array.isArray(astype)) {
          astypes = astype.join(',');
        } else {
          astypes = astype;
        }
        // console.log(astypes);
        getFilteredSpliceVariantByAstype(astypes).then(data =>
          //   console.log(data)
          this.as_query_result = data
        ).catch(err =>
          console.error(err))
      }
    },
    // Datasets
    async getDownloadPageSummary() {
      await getDownloadPageSummary().then(data => {
        if (data) {
          // console.log(data);
          this.download_page_sumamry = data[0];
          this.tcga_summary = data[0].tcga_summary;
          this.gtex_summary = data[0].gtex_summary;
          this.geo_summary = data[0].geo_summary;
          this.tcga_gtex_common_summary = data[0].tcga_gtex_common_summary;
          this.tcga_gtex_dase_summary = data[0].tcga_gtex_dase_summary;
        }
      }).catch(err => {
        console.error(err);
      })
    },
    downloadFiles(fileName) {
      // console.log(fileName);
      downloadFiles(fileName).then(res => {
        // console.log(res); // 返回 Blob 形式,并不会直接进行下载，需创建一个 a 标签去触发下载
        // console.log("success");

        // 将 axios 中 responseType 设置为 blob, 以 blob 形式获取到文件之后,
        // 创建一个 a 标签，设置 url 和 downlaod 后并触发，最后释放 url 资源并删除创建的a标签
        const link = document.createElement('a');
        link.download = fileName;
        link.style.display = 'none'
        // link.href = window.URL.createObjectURL(new Blob([res]));
        link.href = window.URL.createObjectURL(res);

        document.body.appendChild(link)
        link.click()

        //释放URL对象所占资源
        window.URL.revokeObjectURL(link.href)
        //用完即删
        document.body.removeChild(link)
      }).catch(err => {
        console.error(err);
      })
    },
    // goToAnchor(selector) {
    //   this.$el.querySelector(selector).scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    // }
  },
}
</script>
<style scoped lang="sass">
a
  text-decoration: none
  color: #2196F3

a:hover
  text-decoration: underline

.v-data-table ::v-deep th
  font-size: 0.87rem !important
.v-data-table ::v-deep td
  font-size: 0.875rem !important

.v-btn
  text-transform: none
  letter-spacing: 0em
  font-size: 0.875rem

.v-card__title
  line-height: 0.5rem

.v-tab
  text-transform: none

.data-table-style
  border: thin solid rgba(0, 0, 0, 0.12)

.v-item-group
  flex: 0 1 auto
  position: relative
  display: inline-flex
  flex-wrap: wrap
  max-width: 100%
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1)

.breadcrumb
  line-height: 1
  display: inline-block
  margin: 0 0
  vertical-align: middle
  padding: 8px 15px
  margin-top: -5px
  margin-bottom: 10px
  list-style: none
  background-color: #f5f5f5
  border-radius: 4px
</style>